import React, { Component } from 'react'
import { Button, Form, Table, Modal, Input, message, Icon, Upload, Switch, InputNumber, Radio } from 'antd'

import { getGoodsTopic, saveSpecial, reviseSpecial } from '_src/api/api'

import { UploadIMGToOss } from '_src/utils/base'
import './style/special.less'

function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}

@Form.create({ name: 'Special' })
class Special extends Component {
  constructor (props) {
    super(props)
    this.loading = true
    this.id = ''
    this.upLoadFlage = true // 判断图片是否需要更新上传
    this.param = {
      status: '',
      pageNum: 0,
      
    }
    this.status = ''
    this.pageNum = 0
    this.totalElements = 0
    this.state = {
      visible: false,
      dataList: [],
      previewVisible: false,
      previewImage: '',
      fileList: [],
      erroMsg: '',
      modalTitle: '添加专题',
      }
  }

  componentDidMount () {
    this.loadData()
  }
  loadData () {
    const { status, pageNum } = this.param 
    getGoodsTopic({status, pageSize: 10, pageNum})
      .then(res=>{
        this.loading = false
        const { data } = res
        this.totalElements = data.totalElements
        const dataList = data.content.map(item=>{
          return {...item, key: item.id}
        })
        this.setState({
          dataList: dataList,
          visible: false
        })
      })
  }
  columns = () => {
    return [
      {
        title: <span>编号</span>,
        align: 'center',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: <span>分类图标</span>,
        align: 'center',
        dataIndex: 'picUrl',
        render: item => <img src={item} style={{width: 30}} alt='' />
      },
      {
        title: <span>分类名称</span>,
        align: 'center',
        dataIndex: 'name',
      },
      // {
      //   title: <span>专题数量</span>,
      //   align: 'center',
      //   dataIndex: 'link',
      //   render: item => <a href={item} target='_blank'>{item}</a>
      // },
     
      {
        title: <span>专题简介</span>,
        align: 'center',
        dataIndex: 'desc',
        width: 250,
        render: text => <p>{text}</p>
      },
      {
        title: <span>显示状态</span>,
        align: 'center',
        dataIndex: 'status',
        render: item => (<div>{item === 1 
          ? <Icon type="check-circle" theme="twoTone" style={{color: 'green', fontSize: 20}} /> 
          : <Icon type="close-circle" theme="filled" style={{color: '#ccc', fontSize: 20}} /> }</div>)
      },
      {
        title: <span>排序</span>,
        align: 'center',
        dataIndex: 'sortOrder',
        // render: item => <div>{item ? <Icon type="check-circle" theme="twoTone" style={{color: 'green', fontSize: 20}} /> : '/' }</div>
      },
      {
        title: <span>操作</span>,
        align: 'center',
        dataIndex: 'opt',
        render: (_, record) => <div>
          <Button icon="form" type='primary' onClick={()=>{ this.onEdit(record) }} style = {{marginRight: 10}}>编辑</Button>
          {/* <Button icon="close" onClick={()=>{ this.onDelete(item.id) }}>删除</Button> */}
        </div>,
      },
    ]
  }


  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj)
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    })
  };

  handleChange = ({ fileList }) => {
    this.setState({
      erroMsg: ''
    })
    this.upLoadFlage = true
    this.setState({ fileList })
  }
  onEdit (record) {
    this.setState(()=>({
      erroMsg: '',
    }))
    const { picUrl, id } = record || ''
    const fileList = picUrl ? [{ uid: '-1', name: 'xxx.png', status: 'done', url: picUrl}] : []
    this.id = id || ''
    this.upLoadFlage = !toString(this.id) // 重置更新状态
    if(record) {
      this.setState({
        modalTitle: '编辑专题'
      })
    }else{
      this.setState({
        modalTitle: '添加专题'
      })
    }
    this.setState({
      visible: true,
      fileList
    }, ()=>{
      const { status, name, desc, sortOrder } = record || {}
      // 设置对话框信息
      this.props.form.setFieldsValue({
        status: !!status,
        name,
        desc,
        sortOrder,
      })
    })
  }

  onSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { fileList } = this.state
        if (fileList.length === 0) {
          this.setState({
            erroMsg: '请上传图标'
          })
          return
        }
        else {
          this.hide = message.loading(this.id?'专题修改中':'专题添加中', 0)
          // 需要更新图片
          let param = values
          let { status } = param
          status = status? 1 : 0
          param = {...param, status}
          if (this.upLoadFlage) {
            UploadIMGToOss(fileList[0])
              .then((data) => {
                if (data) {
                  status = status? 1 : 0
                  param = {...param, picUrl: data}
                  
                  this.saveSpecial(param)
                } else {
                  this.hide()
                  message.error('图片上传失败！', 1.5)
                }
              })
              .catch(function (err) {
                this.hide()
                message.error('图片上传失败！', 1.5)
                return false
              })
          }
          else {
            // 不需要更新图片
            const { url } = this.state.fileList[0]
            this.saveSpecial({...param, picUrl: url})  
          }
          
          this.setState({
            erroMsg: ''
          })
        }
      }
    })
  }

  // 保存专题
  saveSpecial (param) {
    if (!this.id) {
      // 添加
      saveSpecial(param)
        .then(()=>{
          this.hide && this.hide()
          this.loadData()
          message.success('添加成功', 1.5)
        })
        .catch(()=>{
          this.hide()
          // this.loadData()
          message.success('添加失败', 1.5)
        })
    }
    else {
      // 修改
      reviseSpecial(this.id, param)
        .then(()=>{
          this.hide && this.hide()
          this.loadData()
          message.success('修改成功·=', 1.5)
        })
        .catch(()=>{
          this.hide()
          message.success('修改失败', 1.5, ()=>{
            this.loadData()
          })
        })
    }
  }

  handleEditCancel = () => {
    this.upLoadFlage = true
    this.setState({ visible: false })
  }
  handleSearch = (e) => {
    this.param.status = e.target.value
    this.param.pageNum = 0
    this.loadData()
  }
  pangeChange = (page) => {
    this.param.pageNum = (page - 1)
    this.loadData()
  }
  render () {
    const { dataList, visible, previewVisible, previewImage, fileList, erroMsg, modalTitle } = this.state
    const { getFieldDecorator } = this.props.form

    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">上传</div>
      </div>
    )
    return (
      <div className = "Special">
        <div className = "top">
          <Button type = "primary" icon="plus" onClick = { () => { this.onEdit() } }>添加</Button>
          <Radio.Group defaultValue="" buttonStyle="solid" className = 'searchSelect'
            onChange = { this.handleSearch }
          >
            <Radio.Button value={1}>显示状态</Radio.Button>
            <Radio.Button value="">全部</Radio.Button>
            <Radio.Button value={0}>禁用状态</Radio.Button>
          </Radio.Group>
        </div>
        <Table
          loading = {this.loading} 
          bordered
  
          columns = {this.columns()} 
          dataSource = {dataList}
          pagination = {{ 
            current: (this.param.pageNum + 1),
            total: this.totalElements,
            onChange: (page) => { this.pangeChange(page) }
          }}
        />
        <Modal
          title={modalTitle}
          width={600}
          visible={visible}
          onCancel={this.handleEditCancel}
          footer={false}
          destroyOnClose // 关闭时候销毁
        >
          <Form onSubmit={this.onSubmit} className="advert-form" labelCol = {{span: 4}} wrapperCol = {{span: 18}}>
            <Form.Item label="是否显示">
              {getFieldDecorator('status', { valuePropName: 'checked' })(
                <Switch />
              )}
            </Form.Item>

            <Form.Item label="专题名称" number>
              {getFieldDecorator('name', { rules: [{ required: true, message: '专题名称不能为空', }] })(
                <Input placeholder="请输入专题名称" />)}
            </Form.Item>
            <Form.Item label="位置排序" number>
              {getFieldDecorator('sortOrder', { rules: [{ required: true, message: '位置排序不能为空', }] })(
                <InputNumber placeholder="数字越大越靠前" />)}
            </Form.Item>
            <Form.Item label="专题简介" >
              {
                getFieldDecorator('desc', {
                  rules: [{ required: true, message: '专题简介不能为空' }],
                  initialValue: ''
                })(
                  <Input.TextArea placeholder="请输入专题简介" autosize = {{minRows: 4, maxRows: 8}} maxLength = "200" />
                )
              }
            </Form.Item>

            <Form.Item label="*图片" validateStatus = "error" help={erroMsg}>
              <Upload
                action=""
                listType="picture-card"
                fileList={fileList}
                onPreview={this.handlePreview}
                onChange={this.handleChange}
                beforeUpload = {()=>{ return false }}
                // customRequest={this.Demo}
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
              <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                <img alt="example" style={{ width: '100%' }} src={previewImage} />
              </Modal>
            </Form.Item>
            <Form.Item style={{ paddingLeft: 80 }}>
              <Button type="primary" htmlType="submit" icon='save' style={{ width: 390, float: 'left'}}>保存</Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default Special